var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zwx-scrollbar-x"},[_c('el-scrollbar',{staticClass:"zwx-scrollbar-box-x"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }